import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import './styles.css';
import Content from './Content';

const SidebarItem = (props) => {
  const {
    t, isSidebarExtended, item, location,
  } = props;
  const {
    pageId, iconName, component: ComponentToRender,
  } = item;
  const { pathname } = location;
  const pageTitle = item.pageTitle ? t(item.pageTitle) : '';
  let activeClassName = '';
  let isActive = false;
  if (pathname === pageId) {
    isActive = true;
    activeClassName = 'sidebar-item-extended-active';
  }
  const bottomIcons = ['/settings', '/logout'];
  return (
    <li
      key={pageId}
      className={`sidebar-item ${activeClassName} ${bottomIcons.includes(pageId) ? 'push-bottom' : ''}`}
    >
      {!ComponentToRender
        ? (
          <NavLink to={pageId} className="navLink-sidebar">
            <Content iconName={iconName} pageTitle={pageTitle} {...props} isActive={isActive} />
          </NavLink>
        )
        : (
          <a><ComponentToRender isSidebarExtended={isSidebarExtended} /></a>
        )
      }
    </li>
  );
};

SidebarItem.propTypes = {
  t: PropTypes.func.isRequired,
  isSidebarExtended: PropTypes.bool.isRequired,
  item: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export default translate()(SidebarItem);



// WEBPACK FOOTER //
// ./src/components/SidebarItem/SidebarItem.js